export default function settingsService($http, RESOURCES) {
  var settingsSegment = '/settings';

  return {
    getSettings: getSettings,
    getSettingById: getSettingById,
    updateSettings: updateSettings,
    updateSettingById: updateSettingById,
  };

  function getSettings(merchantId, settingIds) {
    var config = {
      params: {
        settingAttributeIds: settingIds,
      },
    };
    return $http.get(RESOURCES.MERCHANT + '/' + merchantId + settingsSegment, config);
  }

  function getSettingById(merchantId, settingId) {
    return $http.get(RESOURCES.MERCHANT + '/' + merchantId + settingsSegment + '/' + settingId);
  }

  function updateSettingById(merchantId, setting) {
    return $http.put(RESOURCES.MERCHANT + '/' + merchantId + settingsSegment + '/' + setting.id, setting);
  }

  function updateSettings(merchantId, settings) {
    return $http.put(RESOURCES.MERCHANT + '/' + merchantId + settingsSegment, settings);
  }
}



// WEBPACK FOOTER //
// ./src/app/merchants/settings/settings.service.js